import { useState, useEffect } from 'react'
import './NavButtons.css'

const noop = () => {}

const NavButtons = ({ onScreenUpdate = noop }) => {
  const onHome = () => {
    onScreenUpdate('welcome')
  }
  const onSiteMap = () => {
    onScreenUpdate('sitemap')
  }

  const [hovering, setHovering] = useState(false)

  const doHover = (hovering) => {
    setHovering(hovering)
  }

  useEffect(() => {
    if (hovering) {
      const audio = document.getElementById('pop')
      audio.play()
    }
  }, [hovering])

  return (
    <div className="navButtons">
      <audio id="pop" src="../../audio/fx/pop.mp3" />

      <button
        onClick={onHome}
        className="navButton"
        onMouseEnter={() => doHover(true)}
        onMouseLeave={() => doHover(false)}
      >
        <div className="navIcon">🏠</div>
        <div className="navText">Home</div>
      </button>
      <a
        href="https://www.facebook.com/RutgersESC/"
        target="__blank"
        rel="noreferrer"
        className="navButton"
        onMouseEnter={() => doHover(true)}
        onMouseLeave={() => doHover(false)}
      >
        <div className="navIcon">
          <img
            className="navImageIcon"
            src="images/f_logo_RGB-Blue_58.png"
            alt="Facebook Logo"
          />
        </div>
        <div className="navText">Facebook</div>
      </a>
      <a
        href="/pages/main/feedback.html"
        target="__blank"
        rel="noreferrer"
        className="navButton"
        onMouseEnter={() => doHover(true)}
        onMouseLeave={() => doHover(false)}
      >
        <div className="navIcon">
          <img
            className="navImageIcon"
            src="images/envelope.png"
            alt="An envelope"
          />
        </div>
        <div className="navText">Contact Us!</div>
      </a>

      <button
        onClick={onSiteMap}
        className="navButton"
        onMouseEnter={() => doHover(true)}
        onMouseLeave={() => doHover(false)}
      >
        <div className="navIcon">🗺️</div>
        <div className="navText">Sitemap</div>
      </button>

      <a
        href="https://esc.rutgers.edu"
        target="__blank"
        rel="noreferrer"
        className="navButton"
        onMouseEnter={() => doHover(true)}
        onMouseLeave={() => doHover(false)}
      >
        <div className="navIcon">
          <img
            className="navImageIcon"
            src="images/logo192.png"
            alt="Horse Icon"
          />
        </div>
        <div className="navText">ESC</div>
      </a>
    </div>
  )
}

export default NavButtons
